import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';
import PropTypes from 'prop-types';

import StyledLightbox from './lightbox.style';

const Lightbox = forwardRef(
  (
    {
      children = null,
      shouldCloseOnOverlayClick = true,
      shouldFocusAfterRender = true,
      shouldReturnFocusAfterClose = true
    },
    ref
  ) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const lightboxRef = useRef(null);

    const openLightbox = () => setModalIsOpen(true);
    const closeLightbox = () => setModalIsOpen(false);

    // exposes the open/close methods to the parent component when it passes a ref
    useImperativeHandle(ref, () => ({
      openLightbox,
      closeLightbox
    }));

    return (
      <StyledLightbox
        innerRef={lightboxRef}
        isOpen={modalIsOpen}
        onRequestClose={closeLightbox}
        contentLabel="Lightbox"
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        shouldFocusAfterRender={shouldFocusAfterRender}
        shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
      >
        {children}
      </StyledLightbox>
    );
  }
);

Lightbox.displayName = 'Lightbox';

Lightbox.propTypes = {
  children: PropTypes.node,
  shouldCloseOnOverlayClick: PropTypes.bool,
  shouldFocusAfterRender: PropTypes.bool,
  shouldReturnFocusAfterClose: PropTypes.bool
};

export default Lightbox;
